import { AsyncStatus } from "../redux/base.state";
import { AiControlData, TozyMessage } from "./tozy.types";
import { Pagination } from "@/app/types/pagination.types";

export interface TozyState {
  control: AiControlData | null;
  controlStatus: AsyncStatus;
  messages: TozyMessage[];
  pagination: Pagination | null;
  messagesStatus: AsyncStatus;
  sendStatus: AsyncStatus;
    error: string | null;
}

export const initialTozyState: TozyState = {
  control: null,
  controlStatus: "idle",
  messages: [],
  pagination: null,
  messagesStatus: "idle",
  sendStatus: "idle",
    error: null,
};